import styled from 'styled-components';

import { BasicParagraph } from '../../foundations/typefaces/BasicParagraph';
import type { Color } from '../../style/types/theme';
import { Position, Type } from './constants';

const getFoldBackgroundColor = (
  type: Type,
  isPremiumAvailable: boolean,
  color: Color,
): string => {
  if (type === Type.NEW || type === Type.REUSABLE) {
    return color.background.accent.contrast();
  }

  return isPremiumAvailable
    ? // This color doesn't match the context. But this is a exception that we are allowing because the Ribbon component is going to disappear soon
      color.content.tertiary.hover()
    : color.background.premium.hover();
};

const getBackgroundColor = (
  type: Type,
  isPremiumAvailable: boolean,
  color: Color,
): string => {
  if (type === Type.NEW || type === Type.REUSABLE) {
    return color.background.accent.default();
  }

  return isPremiumAvailable
    ? // This color doesn't match the context. But this is a exception that we are allowing because the Ribbon component is going to disappear soon
      color.content.tertiary.default()
    : color.background.premium.default();
};

export interface WrapperProps {
  $type: Type;
  $position: Position;
  $isPremiumAvailable: boolean;
}

export const StyledBasicParagraph = styled(BasicParagraph)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));

export const Wrapper = styled.div<WrapperProps>(
  ({ theme: { color, size, shadow }, $type, $position, $isPremiumAvailable }) => {
    const backgroundColor = getBackgroundColor($type, $isPremiumAvailable, color);
    const foldBackgroundColor = getFoldBackgroundColor($type, $isPremiumAvailable, color);
    const isLeft = $position === Position.LEFT;

    return {
      position: 'relative',
      display: 'flex',
      gap: size.units(1),
      alignItems: 'center',
      padding: `${size.units(0.75)} ${size.units(1.5)}`,
      color: color.content.reversed.default(),
      backgroundColor,
      borderRadius: isLeft
        ? `${size.units(0.5)} ${size.units(0.5)} ${size.units(0.5)} 0`
        : `${size.units(0.5)} ${size.units(0.5)} 0 ${size.units(0.5)}`,
      boxShadow: shadow.short,

      '&:before': {
        content: "''",
        position: 'absolute',
        display: 'block',
        bottom: `-${size.units(1)}`,
        left: isLeft ? 0 : 'auto',
        right: isLeft ? undefined : 0,
        width: size.units(1),
        height: size.units(1),
        borderBottomLeftRadius: isLeft ? '100%' : 0,
        borderBottomRightRadius: isLeft ? undefined : '100%',
        backgroundColor: foldBackgroundColor,
      },
    };
  },
);
